module.exports = __webpack_public_path__ + "static/banner-438c418553b5ccd793267cc7daaf27b2.png";